import * as setupActions from './setupActions'
import { setupTypes } from './setupTypes'

export const setupType = setupTypes
export default setupActions
